import BaseServiceHttp from '../baseService'
class EmprestimosHistoricos extends BaseServiceHttp {
  constructor(id) {
    const resource = 'emprestimos-historicos'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new EmprestimosHistoricos(id)
